import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=0dfc28a9&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=0dfc28a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc28a9",
  null
  
)

export default component.exports